
/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Global definitions ==------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

export const ReportStatus = {
    OK: 0,
    KO: 1,
    NOCONTENT: 2,
    PASSWORDREQUESTED: 3,
    USERCONSENTREQUESTED: 4,
    TIMEOUT: 5,
    NOTFOUND: 6,
    NOTACCEPTABLE: 7,
    GONE: 8
}

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Class definitions ==-------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

/**
 * @description Simple error class that holds a response code
 * */
export class CodeError extends Error {
    constructor(code) {
        super();

        this.code = code;
    }
}

/**
 * @description Report class that simplifies return codes
 */
export class Report {

    constructor(status, code = undefined, data = null) {
        this.status = status;
        this.code = code;
        this.data = data;
    }

    /**
     * @description Static constructor that intantiates a new report with a success code
     * @param { Int? } code
     */
    static ok() {
        return new Report(ReportStatus.OK);
    }

    /**
     * @description Static constructor that intantiates a new report with a failure code code
     * @param { Int? } code
     */
    static ko() {
        return new Report(ReportStatus.KO);
    }

    /**
     * #description Static constcutor that instantiates a new report with an http code, and the corresponding ReportStatus
     * @param {any} code
     */
    static http(code, data = null) {
        let map = new Map([
            [204, ReportStatus.NOCONTENT],
            [403, ReportStatus.TIMEOUT],
            [404, ReportStatus.NOTFOUND],
            [406, ReportStatus.NOTACCEPTABLE],
            [410, ReportStatus.GONE],
        ]);

        let status;
        const defaultStatus = (code >= 200 && code <= 226) ? ReportStatus.OK : ReportStatus.KO;
        if (code === 401) {
            if (data && data.reason === 'passwordRequested') {
                status = ReportStatus.PASSWORDREQUESTED; // Votre propre statut
            } else if (data && data.reason === 'userConsentRequested') {
                status = ReportStatus.USERCONSENTREQUESTED; // Votre propre statut
            } else {
                status = defaultStatus;
            }
        } else {
            
            status = map.get(code) || defaultStatus;
        }

        return new Report(status, code, data);
    }

    /**
     * @description Static constructor that intantiates a new report with an arbitrary code, and some data
     * @param { Int? } code
     */
    static data(data, success = true) {
        return new Report(success ? ReportStatus.OK : ReportStatus.KO, undefined, data);
    }

    /**
     * @description Returns a boolean indicating if the Report is a success or not
     * @returns { Boolean }
     * */
    isSuccess() {
        return this.status === ReportStatus.OK;
    }
}
